<template>
  <b-container fluid class="marketplace-container">
    <IntroVideoModalComponent :customerInfo="customerInfo"/>
    <div class="position-relative content-div">      
      <DropsmartCenterHeaderNavBar 
      :menuItems="menuItems"        
      v-on:navigate="navigate($event)"
      :customerInfo="customerInfo"/>
      
      <DropsmartCenterSideBar 
      :menuItems="menuItems"
      v-on:navigate="navigate($event)"
      :customerLastSubscription="customerLastSubscription"
      :customerInfo="customerInfo"/>
      
      <b-container class="centre-area-content px-0">
        <component 
          :is="contentComponent"
          @updated="contentUpdated"
          :customerInfo="customerInfo"
          :customerLastSubscription="customerLastSubscription"
          :showFreeContent="showFreeContent"
        />
      </b-container>
      
      <div class="child-footer">
        <DropsmartCenterFooter :customerInfo="customerInfo" 
          :customerLastSubscription="customerLastSubscription"/>
      </div>
    </div>
  </b-container>
</template>

<script>
import { BACKEND_URL } from "@/config.js";
import DropsmartCenterHeaderNavBar from "@/components/centre/DropsmartCenterHeaderNavBar.vue";
import DropsmartCenterSideBar from "@/components/centre/DropsmartCenterSideBar.vue";
import CentreMyAccount from "@/views/centre/my-account/CentreMyAccount.vue";
import Perks from "@/views/centre/perks/Perks.vue";
import App from "@/views/centre/app/App.vue";
import Academy from "@/views/centre/academy/Academy.vue";
import LiveQA from "@/views/centre/liveqa/LiveQA.vue";
import Premium from "@/views/centre/premium/Premium.vue";
import Referral from "@/views/centre/referral/Referral.vue";
import Expo from "@/views/centre/expo/Expo.vue";
import DropsmartCenterFooter from "@/components/centre/DropsmartCenterFooter.vue";
import IntroVideoModalComponent from "@/components/centre/IntroVideoModalComponent.vue";

export default {
  title: "Dropsmart Center",
  name: "DropsmartCentre",
  props: ["page"],
  mounted() {
    this.customerInfo = JSON.parse(sessionStorage.getItem("customerInfo"));

    // START LAST SUBSCRIPTION DETAILS
    let url = BACKEND_URL.LastSubscription.replace('VAR_CUSTOMER_ID', this.customerInfo.user.id);
    fetch(url, {
      method: "GET",
      mode: 'cors',
      headers: {
        Accept: 'application/json',
        Authorization: this.customerInfo.token.token,
      },
    })
    .then(response => {
      if(response.ok) {
        return response.json(); 
      } else if (response.status == 404) {
        return null;
      }
    })
    .catch(()=>{ return null; })
    .then(lastSubscription => {
      console.log(lastSubscription != null ? JSON.stringify(lastSubscription) : "User without any valid subscription.");
      this.customerLastSubscription = lastSubscription;
    })
    .catch(error => {
      console.error(error);
    });
    // END LAST SUBSCRIPTION DETAILS

    let routeName = this.$route.name;
    let target = routeName !== 'DropsmartCentre' ? this.$route.name : "Perks";
    console.log("navigating to " + target);
    this.navigate(target);
  },
  components: {
    DropsmartCenterHeaderNavBar,
    DropsmartCenterSideBar,
    CentreMyAccount,
    Perks,
    App,
    Academy,
    Premium,
    LiveQA,
    Referral,
    Expo,
    DropsmartCenterFooter,
    IntroVideoModalComponent,
  },
  data() {
    return {
      showFreeContent: null,
      content: null,
      customerInfo: null,
      customerLastSubscription: null,
      customerSubscriptionDetails: null,
      menuItems: [
        { display: "App", route: "App" },
        { display: "Academy", route: "Academy" },
        { display: "Premium", route: "Premium" },
        { display: "Perks", route: "Perks" },
        { display: "Live Q&A", route: "LiveQA" }
      ]
    };
  },
  watch: {
    async shouldBehaveLikeFree(newValue) {
      await this.updateShowFreeContentValue(newValue);
    },
  },
  computed: {
    contentComponent() {
      return this.content;
    },
    shouldBehaveLikeFree() {
      if(this.customerInfo && this.customerInfo.user && !this.customerInfo.user.paid) {
        if(this.activeOrCancelingSubscription) {
          return false;
        }
        else if(this.customerInfo.user.plan.toUpperCase() === 'FREE') {
            return true;
        } else {
          if(this.customerInfo.user.plan.toUpperCase().startsWith('TRIAL')) {
            //verifying if trial ended or not
            return this.trialEnded; 
          }
        }
        return true;
      } else {
        //paid users
        if (this.activeOrCancelingSubscription == null) {
          return null
        } else if (!this.activeOrCancelingSubscription) {
          return true
        }
      }
      return false;
    },
    trialEnded() {
      if(!this.customerInfo.user.trialEnd) {
        return false;
      }
      let now = new Date();
      let endDate = new Date(this.customerInfo.user.trialEnd);
      return now.getTime() - endDate.getTime() > 0;
    },
    activeOrCancelingSubscription() {
      if(this.customerLastSubscription == null) {
        return null;
      } else if (this.customerLastSubscription && this.customerLastSubscription.status === 'ACTIVE') {
        return true;
      } else if (this.customerLastSubscription && this.customerLastSubscription.status === 'CANCELING') {
        return true;
      }
      return false;
    },
  },
  methods: {
    updateShowFreeContentValue(value) {
      if (value == null) {
        this.showFreeContent = null;
      } else if (value) {
        this.showFreeContent = true;
      } else {
        this.showFreeContent = false;
      }
    },
    navigate(routeName) {
      this.content = routeName;
    },
    contentUpdated() {
      this.customerInfo = JSON.parse(sessionStorage.getItem("customerInfo"));
    },
  },
};
</script>

<style lang="scss">
/* ====GENERAL================================================== */
html,
body,
#app {
  height: 100%;
}
/* ====Hide toolbar============================================= */
body::-webkit-scrollbar {
  display: none;
}
html {
  scrollbar-width: none;
}

div#intro-video-modal::-webkit-scrollbar,
div#free-modal::-webkit-scrollbar, 
div#modal-academy::-webkit-scrollbar, 
div#modal-perk::-webkit-scrollbar,
div#modal-premium::-webkit-scrollbar {
    display: none;
}

div#intro-video-modal___BV_modal_outer_ {
  div#intro-video-modal {
  padding-left: 0 !important;
}
}

div#free-modal___BV_modal_outer_ {
  div#free-modal {
  padding-left: 0 !important;
}
}

div#modal-premium___BV_modal_outer_ {
  div#modal-premium {
  padding-left: 0 !important;
}
}

div#modal-perk___BV_modal_outer_ {
  div#modal-perk {
  padding-left: 0 !important;
}
}

div#modal-academy___BV_modal_outer_ {
  div#modal-academy {
  padding-left: 0 !important;
}
}
</style>

<style scoped lang="scss">
$bg-gray: #f7f7f7;
$bg-footer-dark-gray: #d9d9d9;

main {
  overflow-x: hidden;
  height: 100%;
}

.marketplace-container {
  margin-top: 1rem;
  justify-content: center;
  display: flex;
}

.content-div {
  max-width: 1000px;
}

.child-footer {
  width: 100vw;
  //margin: auto;
  position: relative;
  left: calc(-50vw + 50%);

  background-color: $bg-footer-dark-gray;

  margin-top: 5rem;
}

@media screen and (max-width: 1023px) {
  .marketplace-container {
    display: block;
  }
}
</style>
